module.exports = __webpack_public_path__ + "assets/img/ahospital.53302a08.png";